import { render, staticRenderFns } from "./ViewLoad.vue?vue&type=template&id=19453e22&scoped=true"
import script from "./ViewLoad.vue?vue&type=script&lang=js"
export * from "./ViewLoad.vue?vue&type=script&lang=js"
import style0 from "./ViewLoad.vue?vue&type=style&index=0&id=19453e22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19453e22",
  null
  
)

export default component.exports